// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_KDt","index":"styles_index__1K2HV"};